import { Exact, UpdateRoleMutation, UpdateRole__Input, useUpdateRoleMutation } from '../../../../../graphql'
import { useShowSuccess, useShowError } from 'hooks/useToast'
import { MutationHookOptions } from '@apollo/client'

export default function useUpdateRoleHandler( options?: MutationHookOptions<UpdateRoleMutation, Exact<{ input: UpdateRole__Input }>> ) {
	const [ updateRole ] = useUpdateRoleMutation( options )
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async( roleId: number, name: string, spendingLimit?: number ) => {
		const { data } = await updateRole( { variables: { input: { roleId, name, spendingLimit } } } )

		if ( data?.updateRole?.success ) {
			showSuccess( `editRoleSuccess${Date.now()}`, data?.updateRole?.message ?? 'Successfully updated role!' )
		} else {
			showError( `editRoleError${Date.now()}`, data?.updateRole?.message ?? 'Sorry, an error occurred' )
		}
	}
}
